import axios from "axios";

export const AxiosInstance = axios.create({
  baseURL: "https://erp.suryamanisolar.com/api/",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
})